export const FETCH_MEMBERS_REPORTS = "FETCH_MEMBERS_REPORTS";
export const FETCH_MEMBERS_REPORTS_SUCCESS = "FETCH_MEMBERS_REPORTS_SUCCESS";
export const FETCH_MEMBERS_REPORTS_FAILED = "FETCH_MEMBERS_REPORTS_FAILED";

export const EXPORT_TO_EXCEL = "EXPORT_TO_EXCEL";
export const EXPORT_TO_EXCEL_SUCCESS = "EXPORT_TO_EXCEL_SUCCESS";
export const EXPORT_TO_EXCEL_FAILED = "EXPORT_TO_EXCEL_FAILED";

export const FETCH_NON_MEMBERS_REPORTS = "FETCH_NON_MEMBERS_REPORTS";
export const FETCH_NON_MEMBERS_REPORTS_SUCCESS =
  "FETCH_NON_MEMBERS_REPORTS_SUCCESS";
export const FETCH_NON_MEMBERS_REPORTS_FAILED =
  "FETCH_NON_MEMBERS_REPORTS_FAILED";

export const FETCH_RIDES_REPORTS = "FETCH_RIDES_REPORTS";
export const FETCH_RIDES_REPORTS_SUCCESS = "FETCH_RIDES_REPORTS_SUCCESS";
export const FETCH_RIDES_REPORTS_FAILED = "FETCH_RIDES_REPORTS_FAILED";

export const EXPORT_TO_EXCEL_RIDES_REPORTS = "EXPORT_TO_EXCEL_RIDES_REPORTS";
export const EXPORT_TO_EXCEL_RIDES_REPORTS_SUCCESS =
  "EXPORT_TO_EXCEL_RIDES_REPORTS_SUCCESS";
export const EXPORT_TO_EXCEL_RIDES_REPORTS_FAILED =
  "EXPORT_TO_EXCEL_RIDES_REPORTS_FAILED";

export const FETCH_EVENTS_REPORTS = "FETCH_EVENTS_REPORTS";
export const FETCH_EVENTS_REPORTS_SUCCESS = "FETCH_EVENTS_REPORTS_SUCCESS";
export const FETCH_EVENTS_REPORTS_FAILED = "FETCH_EVENTS_REPORTS_FAILED";

export const EXPORT_TO_EXCEL_EVENTS_REPORTS = "EXPORT_TO_EXCEL_EVENTS_REPORTS";
export const EXPORT_TO_EXCEL_EVENTS_REPORTS_SUCCESS =
  "EXPORT_TO_EXCEL_EVENTS_REPORTS_SUCCESS";
export const EXPORT_TO_EXCEL_EVENTS_REPORTS_FAILED =
  "EXPORT_TO_EXCEL_EVENTS_REPORTS_FAILED";

export const FETCH_BRANCH_REPORTS = "FETCH_BRANCH_REPORTS";
export const FETCH_BRANCH_REPORTS_SUCCESS = "FETCH_BRANCH_REPORTS_SUCCESS";
export const FETCH_BRANCH_REPORTS_FAILED = "FETCH_BRANCH_REPORTS_FAILED";

export const EXPORT_TO_EXCEL_BRANCH_REPORTS = "EXPORT_TO_EXCEL_BRANCH_REPORTS";
export const EXPORT_TO_EXCEL_BRANCH_REPORTS_SUCCESS =
  "EXPORT_TO_EXCEL_BRANCH_REPORTS_SUCCESS";
export const EXPORT_TO_EXCEL_BRANCH_REPORTS_FAILED =
  "EXPORT_TO_EXCEL_BRANCH_REPORTS_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";
